import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=6f826426&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f826426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f826426')) {
      api.createRecord('6f826426', component.options)
    } else {
      api.reload('6f826426', component.options)
    }
    module.hot.accept("./ButtonGroup.vue?vue&type=template&id=6f826426&scoped=true&", function () {
      api.rerender('6f826426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonGroup.vue"
export default component.exports